import { API_URL } from '@/config';
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${API_URL}/api`;

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      // First check localStorage for stored user
      const storedUser = localStorage.getItem('user');
      const token = localStorage.getItem('session_token');
      
      if (storedUser && token) {
        // Verify token is still valid
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          if (isMounted) {
            setUser(response.data);
            setIsAuthenticated(true);
            // Update stored user with fresh data
            localStorage.setItem('user', JSON.stringify(response.data));
          }
        } catch (error) {
          // Token invalid, clear storage
          localStorage.removeItem('session_token');
          localStorage.removeItem('user');
          if (isMounted) {
            setIsAuthenticated(false);
          }
        }
      } else {
        if (isMounted) {
          setIsAuthenticated(false);
        }
      }
      
      if (isMounted) {
        setLoading(false);
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (isAuthenticated === false) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && user) {
    const adminRoles = ['Super Admin', 'President', 'Secretary', 'Treasurer'];
    if (!adminRoles.includes(user.role)) {
      return <Navigate to="/app" replace />;
    }
  }

  return React.cloneElement(children, { user });
};

export default ProtectedRoute;
